import { React, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Skeleton,
  styled,
} from "@mui/material";
import {
  getUserProfile,
  addCurrentAccount,
} from "../../store/reducers/userProfileReducer";
import {
  CleartraderJournalNew,
  ClearAccountDetails,
  AccountDetails,
  filterAccount,
  filterActiveAc,
  DashboardAcHeading,
  setAccountType,
  setActiveInActive,
  setActiveInactive,
  fetchAccountDetails,
} from "../../store/reducers/dashboardReducer.js";
import "./Header.scss";
import dollar from "../../assets/images/dollaricon.svg";
import dollarComp from "../../assets/images/DollarGreen.svg";
import alphaIcon from "../../assets/images/alphaIcon.svg";

import freeTrailIcon from "../../assets/images/freeTrialIcon.svg";
import edit from "../../assets/images/Edit-alt.svg";
import HeadAndSub from "../ReusableComponents/HeadAndSub";
import { useNavigate } from "react-router-dom";
import CharmTick from "../../assets/images/charm_tick.svg";
import { dollarUS } from "../../utilities/formatters";
import { CheckBox, CheckBoxOutlineBlankOutlined } from "@mui/icons-material";
import Loader from "../../reusableComponents/Loader/index.js";
import { NewDashboard } from "../../pages/index.js";

const NotificationBox = ({ onEditclick, handleClose }) => {
  const { filteredActiveAc } = useSelector((state) => state.dashboard);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user_profile = useSelector((state) => state.user);
  const AccDetails = useSelector((state) => state.dashboard.AccDetails);
  const [GeneralInfo, setGeneralInfo] = useState(false);
  const [Statistics, setStatistics] = useState(false);
  const [plans, setPlans] = useState([]);
  const [Username, setUsername] = useState("");
  const [ProfilePic, setProfilePic] = useState(false);
  const [DropdownAccounts, setDropdownAccounts] = useState(false);
  const [CurrentAcc, setCurrentAcc] = useState(false);
  const [Tick, setTick] = useState(false);
  const [selectedAccType, setSelectedAccType] = useState(false);
  const [initDrop, setInitDrop] = useState();
  const [isActive, setIsActive] = useState(
    filteredActiveAc === "active" ? false : true
  );
  const loader = useSelector((state) => state.loader.is_loading);
  const [open, setOpen] = useState(loader);
  const [filter, setFilter] = useState(selectedAccType);
  const dashboard = useSelector((state) => state.dashboard.newdashboard);
  const [filterValue, setFilterValue] = useState();
  console.log(user_profile?.trading_accounts, "user_profileuser_profile");

  useEffect(() => {
    setOpen(loader);
  }, [loader]);

  useEffect(() => {
    console.log(isActive, "activestatus");
  }, [filterActiveAc]);

  const handleAccountChange = (login_id, accountType, platform , activeStatus) => {

    console.log(login_id, accountType, platform,"login_id, accountType, platform")
    dispatch(ClearAccountDetails());
    dispatch(CleartraderJournalNew());

    dispatch(addCurrentAccount({ login_id, platform , accountType , activeStatus }));
    // setTick(login_id);
    // setSelectedAccType(accountType)
    dispatch(setActiveInactive(activeStatus));

  };


  useEffect(() => {
    dispatch(getUserProfile());
    dispatch(AccountDetails(AccDetails));
    // dispatch(fetchAccountDetails(CurrentAcc));
  }, [dispatch, CurrentAcc]);

  useEffect(() => {
    if (Object.keys(user_profile).length) {
      user_profile.full_name && setUsername(`${user_profile.full_name}`);
      user_profile.photo && setProfilePic(user_profile.photo);

      if (user_profile.current_account) {
        setCurrentAcc(user_profile.current_account);

        if (user_profile.trading_accounts) {
          if (user_profile.trading_accounts.length) {
            const info = user_profile.trading_accounts.filter(
              (account) => account.login_id === user_profile.current_account
            );
            if (info.length) {
              const data = info[0];
              setGeneralInfo(data);
              setTick(data.login_id);
              setSelectedAccType(data.category);
              setIsActive(data.is_Active);
            }
          }
        }
      }

      if (user_profile?.trading_accounts?.length) {
        setDropdownAccounts(user_profile.trading_accounts);
        setPlans([
          ...new Set(
            user_profile?.trading_accounts?.map((obj) => obj.category)
          ),
        ]);
      }
    }

  }, [user_profile]);
  useEffect(() => {
    setStatistics(AccDetails);
  }, [AccDetails]);

  const BpIcon = styled("span")(({ theme }) => ({
    borderRadius: "50%",
    width: 14,
    height: 14,
    boxShadow:
      theme.palette.mode === "dark"
        ? "0 0 0 1px rgb(16 22 26 / 40%)"
        : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: theme.palette.mode === "dark" ? "#394b59" : "#f5f8fa",
    backgroundImage:
      theme.palette.mode === "dark"
        ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
        : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    ".Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: theme.palette.mode === "dark" ? "#30404d" : "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background:
        theme.palette.mode === "dark"
          ? "rgba(57,75,89,.5)"
          : "rgba(206,217,224,.5)",
    },
  }));

  const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: "#04D9FF",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 14,
      height: 14,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  });

  const { filteredbyaccount } = useSelector((state) => state.dashboard);

  console.log(filteredbyaccount, "filteredbyaccountfilteredbyaccount");
  const [filterValues, setFilterValues] = useState(filteredbyaccount);
  const allPlans = [...plans, "All"];
  // console.log(allPlans,'allPlansss')
  useEffect(() => {
    setFilterValues(filteredbyaccount);
  }, [filteredbyaccount, filteredActiveAc]);

  useEffect(() => {
    if (!filteredbyaccount) {
      dispatch(filterAccount(allPlans[4]));
      dispatch(DashboardAcHeading(`${allPlans[4]} Accounts`));
    } else if (filteredbyaccount) {
      dispatch(filterAccount(selectedAccType));
    }
  }, [filterValues, selectedAccType, dispatch]);

  const [newFilterValues, setNewFilterValues] = useState(
    user_profile?.trading_accounts || []
  );

  const { isActiveInactive, accountType } = useSelector(
    (state) => state.dashboard
  );

  useEffect(() => {
    // Ensure default values are set in Redux
    if (isActiveInactive === null || isActiveInactive === undefined) {
      const initialStatus = user_profile?.current_status === true ? true : false;
      dispatch(setActiveInactive(initialStatus));
            console.log(user_profile?.current_status)
    }
    if (accountType === null || accountType === undefined) {
      dispatch(setAccountType(user_profile?.current_type || "all"));
    }

    // Filter logic
    const filteredByAccount = user_profile?.trading_accounts?.filter((item) => {
      const matchesAccountType =
        accountType === "all" || item.category.toLowerCase() === accountType;
      const matchesActiveStatus =
        isActiveInactive === null || item.is_Active === isActiveInactive;

      return matchesAccountType && matchesActiveStatus;
    });

    setNewFilterValues(filteredByAccount || []);
  }, [accountType, isActiveInactive, user_profile?.trading_accounts, dispatch]);

  return (
    <div className="NotificationContainer d-flex">
      <div className="AllAccBox mbb-20">
        <div className="NFName mbb-10">Account Type</div>
        <div className="AllAccWrapper">
          {allPlans.length &&
            allPlans.map((data, key) => (
              <div className="d-flex AccDetail-type" key={key}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Checkbox
                    sx={{
                      color: "#8F8F8F",
                      "&.Mui-checked": {
                        color: "#0640B9 ",
                      },
                    }}
                    checked={accountType === data?.toLowerCase()}
                    onClick={() => {
                      console.log(
                        accountType,
                        accountType === data?.toLowerCase(),
                        "accountType === data?.toLowerCase()accountType === data?.toLowerCase()"
                      );
                      return dispatch(setAccountType(data?.toLowerCase()));
                    }}
                  />
                  <div
                    className="AllAccData"
                    onClick={() =>
                      dispatch(setAccountType(data?.toLowerCase()))
                    }
                  >
                    {data}
                  </div>
                </div>
              </div>
            ))}
        </div>

        <div className="LiveAccBox">
          <div className="NFName mbb-10">Account Stage</div>
          <FormControl>
            <RadioGroup
              row
              value={isActiveInactive !== undefined ? isActiveInactive : (user_profile?.current_status === "true" ? true : false)} // Convert string "true" to boolean true
              onChange={(e) =>
                dispatch(setActiveInactive(e.target.value === "true"))
              }
            >
              <FormControlLabel
                className={isActiveInactive ? "active" : ""}
                value={true}
                control={<Radio disableRipple />}
                label={
                  <span style={{ fontSize: "14px", fontFamily: "Outfit" }}>
                    Active
                  </span>
                }
              />
              <FormControlLabel
                className={!isActiveInactive ? "active" : ""}
                value={false}
                control={<Radio />}
                label={
                  <span style={{ fontSize: "14px", fontFamily: "Outfit" }}>
                    Inactive
                  </span>
                }
              />
            </RadioGroup>
          </FormControl>

          <div className="accountIds_wrapper">
            {newFilterValues &&
              newFilterValues?.map((item, key) => (
                <div
                  onClick={() =>
                    handleAccountChange(
                      item.login_id,
                      accountType,
                      item.platform,
                      item.is_Active
                    )
                  }
                  className={`d-flex AccDetail-type ${
                    Tick === item.login_id ? "active" : ""
                  }`}
                  key={key}
                >
                  <div style={{ display: "flex" }}>
                    <img
                      src={accountType === "competition" ? dollarComp : dollar}
                      alt=""
                    />
                    <div className="LiveAccData">
                      {item.login_id}
                      <div className="LiveMinData">
                        {/* Additional item details */}
                      </div>
                    </div>
                  </div>
                  {Tick === item.login_id && (
                    <div className="img-wrapper">
                      <img src={CharmTick} alt="" />
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>
      </div>

      {/* <div className="mrr-20 LineBreak">
        <svg
          width="2"
          height="278"
          viewBox="0 0 1 278"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line
            opacity="0.4"
            x1="0.5"
            y1="277.5"
            x2="0.50001"
            y2="0.5"
            stroke="url(#paint0_radial_348_6843)"
            strokeLinecap="round"
          />
          <defs>
            <radialGradient
              id="paint0_radial_348_6843"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(1.00001 133.574) rotate(90) scale(144.426 24238.7)"
            >
              <stop offset="0.42336" stopColor="white" />
              <stop offset="1" stopColor="white" stopOpacity="0" />
            </radialGradient>
          </defs>
        </svg>
      </div> */}
      <div className="DetailsBox" style={{ position: "relative" }}>
        <Loader open={open} top={"35%"} />
        <div className="NFName mbb-10">Account Detail</div>
        <div className="Profile-Box">
          <div className="gapp-10 d-flex align-items-center">
            <div>
              {ProfilePic ? (
                <img
                  src={ProfilePic}
                  alt="Profile"
                  width="40"
                  height="40"
                  style={{ borderRadius: "50%" }}
                />
              ) : (
                <Skeleton
                  sx={{ bgcolor: "#222c3a" }}
                  animation={!Object.keys(user_profile).length && true}
                  variant="circular"
                  width={40}
                  height={40}
                />
              )}
            </div>
            <div>
              <div className="Profile-Name">
                {Username ? (
                  Username
                ) : (
                  <Skeleton
                    sx={{ bgcolor: "#222c3a" }}
                    animation={!Object.keys(user_profile).length && true}
                    variant="text"
                  />
                )}
              </div>
              <div className="Profile-Acc">{CurrentAcc || false}</div>
            </div>
            <div className="img-wrapper" onClick={(e) => navigate("/profile")}>
              <img
                className=""
                src={edit}
                alt="editIcon"
                style={{ marginBottom: "20px" }}
                onClick={handleClose}
              />
            </div>
          </div>
          <div className="mtt-20 DetailsList">
            <div style={{ width: "100%" }} className="">
              <HeadAndSub
                HeadAndSubClassName="mbb-20"
                HeadTitle="Start Date"
                SubTitle={
                  GeneralInfo &&
                  Object.keys(GeneralInfo).length &&
                  GeneralInfo.start_date &&
                  new Date(GeneralInfo.start_date).toDateString()
                }
              />
              {/* <HeadAndSub
                HeadAndSubClassName="mbb-20"
                HeadTitle="No. of trades"
                SubTitle={
                  Statistics && Statistics.totalTrades
                    ? dollarUS(Statistics.totalTrades)
                    : false
                }
              /> */}

              <HeadAndSub
                HeadAndSubClassName="mbb-20"
                HeadTitle="Expiry Date"
                SubTitle={
                  GeneralInfo &&
                  Object.keys(GeneralInfo).length &&
                  GeneralInfo.expiry_date &&
                  new Date(GeneralInfo.expiry_date).toDateString()
                }
              />
              <HeadAndSub
                HeadAndSubClassName="mbb-20"
                HeadTitle="Leverage"
                SubTitle={
                  Statistics &&
                  Object.keys(Statistics).length &&
                  Statistics.challenge.Leverage
                }
              />
              <div className="boxes">
                <HeadAndSub
                  HeadAndSubClassName="mbb-20"
                  HeadTitle="Balance"
                  SubTitle={
                    Statistics && Statistics.balance
                      ? dollarUS(Statistics.balance)
                      : false
                  }
                />
                <HeadAndSub
                  HeadAndSubClassName="mbb-20"
                  HeadTitle="Equity"
                  SubTitle={
                    Statistics && Statistics.equity
                      ? dollarUS(Statistics.equity)
                      : false
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NotificationBox;
